export function redirectToCanonicalAppUrl(appUrl) {
    if (!appUrl || typeof window === 'undefined') {
        return false;
    }

    const { hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return false;
    }

    let canonicalOrigin;
    try {
        canonicalOrigin = new URL(appUrl).origin;
    } catch {
        return false;
    }

    if (window.location.origin === canonicalOrigin) {
        return false;
    }

    window.location.replace(canonicalOrigin);
    return true;
}
